/**
 * The text inside a progress ring. "12/20" while it fits; past five characters (1231/1370) it
 * would spill over the ring, so it becomes a whole percentage. Floored, so 100% means all done.
 */
export function ringLabel(value: number, total: number): string {
  const fraction = `${value}/${total}`;
  if (fraction.length <= 5) return fraction;
  return `${total ? Math.floor((Math.min(value, total) / total) * 100) : 0}%`;
}
